export enum Wishlist {
    CUSTOMER = 'customer',
    DEALER = 'dealer'
}
